module.exports = __webpack_public_path__ + "static/media/logo2.346eca87.png";